module.exports = __webpack_public_path__ + "img/nl.atag.connectlife.19b948cd.webp";